<template>
  <div id="searchLoc">
    <a-cascader
      :field-names="{ label: 'value', value: 'key', children: 'childList' }"
      :options="option"
      :autoFocus="false"
      placeholder="城市"
      @change="onChange"
      :display-render="displayRender"
      :popupStyle="{}"
    />
  </div>
</template>
<script>
import { GetAreaList } from "@/api/search.js";

export default {
  name: "SearchLoc",
  props: ["markerPoint", "show"],
  data() {
    return {
      option: [],
    };
  },
  created() {
    this.GetArea();
  },
  methods: {
    onChange(value) {
      let addressSelect = [...value];
      this.$emit("selectValue", addressSelect);
    },
    displayRender({ labels }) {
      return labels[labels.length - 1];
    },
    GetArea() {
      GetAreaList()
        .then((res) => {
          this.option = res;
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
  },
};
</script>
<style scoped>
#searchLoc {
  position: relative;
}
#searchLoc >>> .ant-cascader-input.ant-input {
  border: none;
  width: 100px;
  height: 41px;
}
#searchLoc >>> .ant-input:focus {
  box-shadow: none !important;
}
/* #searchLoc >>> .el-cascader__dropdown {
  height: 500px;
  overflow: auto;
} */
</style>
